export const TRI_CONTRACT = process.env.REACT_APP_TRI_CONTRACT as string;
export const POLYGON_USDT = '0xc2132D05D31c914a87C6611C10748AEb04B58e8F';
export const POLYGON_EDOGE = '0x0AcD96e7b895D534D2216c6Fb5B98fD91Da70C3f';
export const POLYGON_SHUFFLE =
  process.env.NODE_ENV === 'development'
    ? '0x0dD91c7115dAF495CdCEa55067cBe2c2EEab14b8'
    : '0x0dD91c7115dAF495CdCEa55067cBe2c2EEab14b8';
export const POLYGON_TRI =
  process.env.NODE_ENV === 'development'
    ? '0x319Cc2379c8610F43c687d9B6E9CC5133519A783'
    : '0x319Cc2379c8610F43c687d9B6E9CC5133519A783';
